"use strict";
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Secondary = exports.Primary = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  title: 'Button',
  component: _index.Button,
  argTypes: {
    backgroundColor: {
      control: 'color'
    }
  }
};
exports.default = _default;

var Template = function Template(args) {
  return /*#__PURE__*/_react.default.createElement(_index.Button, args);
};

var Primary = Template.bind({});
exports.Primary = Primary;
Primary.args = {
  type: 'primary',
  label: 'Button 1'
};
var Secondary = Template.bind({});
exports.Secondary = Secondary;
Secondary.args = {
  type: 'secondary',
  label: 'Button 2'
};
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
  var label = _ref.label,
      type = _ref.type;
  var cls = type || 'primary';
  return /*#__PURE__*/_react.default.createElement("button", {
    className: "ui-button ".concat(cls)
  }, label);
};

exports.Button = Button;
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Login = void 0;

var _react = _interopRequireDefault(require("react"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = function Login() {
  return /*#__PURE__*/_react.default.createElement("div", null, "Login");
};

exports.Login = Login;
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Primary = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  title: 'Login',
  component: _index.Login,
  argTypes: {
    backgroundColor: {
      control: 'color'
    }
  }
};
exports.default = _default;

var Template = function Template(args) {
  return /*#__PURE__*/_react.default.createElement(_index.Login, args);
};

var Primary = Template.bind({});
exports.Primary = Primary;
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Nav = void 0;

var _react = _interopRequireDefault(require("react"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Nav = function Nav(_ref) {
  var data = _ref.data,
      authenticated = _ref.authenticated;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "nav"
  }, data.map(function (d, idx) {
    return d.show !== false && (!d.auth && !authenticated || d.auth && authenticated) && /*#__PURE__*/_react.default.createElement("div", {
      className: "nav-item",
      key: "nav_item_".concat(idx),
      onClick: d.action
    }, d.icon && /*#__PURE__*/_react.default.createElement("div", {
      className: "nav-icon"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: d.icon,
      alt: "CSG Navigation Icon"
    })), /*#__PURE__*/_react.default.createElement("div", {
      key: d.name,
      className: "nav-txt"
    }, d.name));
  }));
};

exports.Nav = Nav;
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Primary = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  title: 'Nav',
  component: _index.Nav
};
exports.default = _default;

var Template = function Template(args) {
  return /*#__PURE__*/_react.default.createElement(_index.Nav, args);
};

var Primary = Template.bind({});
exports.Primary = Primary;
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import './src/lib/components/UISelect/style.css';
var Select = function Select(_ref) {
  var label = _ref.label,
      data = _ref.data;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, label), /*#__PURE__*/_react.default.createElement("select", null, data === null || data === void 0 ? void 0 : data.map(function (d) {
    return /*#__PURE__*/_react.default.createElement("option", null, d.label);
  }), ";"));
};

exports.Select = Select;
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectTwo = exports.SelectThree = exports.SelectOne = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  title: 'Select',
  component: _index.Select,
  argTypes: {
    backgroundColor: {
      control: 'color'
    }
  }
};
exports.default = _default;

var Template = function Template(args) {
  return /*#__PURE__*/_react.default.createElement(_index.Select, args);
};

var SelectOne = Template.bind({});
exports.SelectOne = SelectOne;
SelectOne.args = {
  data: [{
    label: 'option 1'
  }, {
    label: 'option 2'
  }],
  label: 'Select 1'
};
var SelectTwo = Template.bind({});
exports.SelectTwo = SelectTwo;
SelectTwo.args = {
  data: [{
    label: 'option 3'
  }, {
    label: 'option 4'
  }],
  label: 'Select 2'
};
var SelectThree = Template.bind({});
exports.SelectThree = SelectThree;
SelectThree.args = {
  data: [{
    label: 'option 5'
  }, {
    label: 'option 6'
  }],
  label: 'Select 3'
};
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import './src/lib/components/UITitle/style.css';
var Title = function Title(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "ui-label"
  }, label || '');
};

exports.Title = Title;
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Small = exports.Large = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  title: 'Title',
  component: _index.Title,
  argTypes: {
    backgroundColor: {
      control: 'color'
    }
  }
};
exports.default = _default;

var Template = function Template(args) {
  return /*#__PURE__*/_react.default.createElement(_index.Title, args);
};

var Large = Template.bind({});
exports.Large = Large;
Large.args = {
  label: 'Title Test 3'
};
var Small = Template.bind({});
exports.Small = Small;
Small.args = {
  label: 'Title Test 4'
};
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UiChart = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactCharts = require("react-charts");

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var data = [{
  label: 'Series 1',
  data: [[0, 1], [1, 2], [2, 4], [3, 2], [4, 7]]
}, {
  label: 'Series 2',
  data: [[0, 3], [1, 1], [2, 5], [3, 6], [4, 4]]
}];
var axes = [{
  primary: true,
  type: 'linear',
  position: 'bottom'
}, {
  type: 'linear',
  position: 'left'
}];

var UiChart = function UiChart() {
  return (
    /*#__PURE__*/
    // A react-chart hyper-responsively and continuously fills the available
    // space of its parent element automatically
    _react.default.createElement("div", {
      style: {
        width: '400px',
        height: '300px'
      }
    }, /*#__PURE__*/_react.default.createElement(_reactCharts.Chart, {
      data: data,
      axes: axes
    }))
  );
};

exports.UiChart = UiChart;
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Primary = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  title: 'UiChart',
  component: _index.UiChart
};
exports.default = _default;

var Template = function Template(args) {
  return /*#__PURE__*/_react.default.createElement(_index.UiChart, args);
};

var Primary = Template.bind({});
exports.Primary = Primary;
